import { EDI271AAADetailBO, EDI271LoopDetailBO } from "../eligibility270/eligibility270.model";

export class ClientBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  firstName: string;
  lastName: string;
  middleName: string;
  status_Name: string;
  userName: string;
  dOB: string | null;
  weight: number | null;
  aKA: string;
  isEin: string;
  medicaid: string;
  medicare: string;
  street: string;
  street2: string;
  apt: string;
  phone1: string;
  phone2: string;
  county: string;
  city: string;
  age: number | null;
  state: string;
  zipCode: string;
  ssn: string;
  email: string;
  requireEVV: boolean;
  internalId: string;
  pClientId: string;
  insuranceNo: string;
  billto_Name: string;
  billto_Street: string;
  billto_City: string;
  billto_State: string;
  billto_Zipcode: string;
  billto_Phone: string;
  billto_Email: string;
  mA_PMI: string;
  county_fiscalResponsibility: string;
  locationId: string;
  priorityStatusLid: string | null;
  genderLid: string;
  assessmentRatingLid: string | null;
  pCATypeLid: string | null;
  typeofWaiverLid: string | null;
  isEinLid: string | null;
  statusLid: string;
  agencyId: string;
  loginUserId: string | null;
  locationName: string;
  name: string;
  gender_Name: string;
  assessmentRatingName: string;
  pCATypeName: string;
  typeofWaiverName: string;
  priorityStatusName: string;
  languageLid: any[] = [];
  icD10Id: string = null;
  icD10Code: string;
  payerId: string;
  paySource: string;
  isHomelessClient:boolean =false;
  cfssAgencyId:string | null;
  cyma_suta_rate:number;
  isMAEligible:boolean;
  spendDown:boolean;
  waiver:string;
}





export class ClientReturnBO {
  clientId: string;
  errorList: string[];
}
export class QPfilter {
  Client: number = 0;
  QPEMP: number = 0;
  Status: string = "00000000-0000-0000-0000-000000000000";
}
export class GetClientEmployeeRelationshipBO {
  id: string;
  clientId: string;
  employeeId: string;
  statusLid: string;
  employeeName: string;
  clientName: string;
}

export class EditDetailsClient {
  newclient = false;
  isCheckClientView: boolean | null;
  isView: boolean = false;
  isEdit: boolean = false;
  isnewClient: boolean;
  isEditClient: boolean = false;
  clientId: string = "00000000-0000-0000-0000-000000000000";
  iscounsumer: boolean = false;
  isaid: boolean = false;
  isaidandConsumer: boolean = false;
  consumerId: string = "00000000-0000-0000-0000-000000000000";
  clientData: ClientBO = new ClientBO();
  isclientfilterEnable: boolean = false;
  addpreviousdata: any;
  isconsumeraddpreviousdata: boolean = false;
  basicCareId: string = "00000000-0000-0000-0000-000000000000";
  isEditbasicPlan: boolean = false;
  iclsCareId: string = "00000000-0000-0000-0000-000000000000";
  isEditiclsPlan: boolean = false;
  rowIndex: string | null;
  isHomeMakingCarePlanAdvanced: boolean | null;
  isComprehensiveNew: boolean = false;
  homeCareId: string = "00000000-0000-0000-0000-000000000000";
  isEditHomePlan: boolean = false;
}


export class ResponsibleInfoLst {
  name: string;
  email: string;
  alternatePhoneNumber: string;
  city: string;
  county: string;
  fax: string;
  phoneNumber: string;
  relationship: string;
  state: string;
  street: string;
  zipCode: string;
}

export class EmergencyContactInfoLst {
  alternatePhoneNumber: string;
  city: string;
  county: string;
  email: string;
  fax: string;
  name: string;
  phoneNumber: string;
  relationship: string;
  state: string;
  street: string;
  zipCode: string;
}
export class CaregiverInfoLst {
  age: string;
  apt: string;
  city: string;
  county: string;
  email: string;
  name: string;
  phone1: string;
  phone2: string;
  steet: string;
  street: string;
  zipcode: string;
}
export class OfficeCaseManagerInfoLst {
  alternateFax: string;
  county: string;
  email: string;
  fax: string;
  name: string;
  phone: string;
}

////contact tab Bo////
export class ContactInfoLst {
  id: string = "00000000-0000-0000-0000-000000000000";
  name: string;
  street: string;
  city: string;
  state: string;
  zipCode: string;
  county: string;
  phoneNumber: string;
  alternatePhoneNumber: string;
  fax: string;
  email: string;
  contactTypeLid: string;
  relationshipLid: string | null;
  phoneCarrierLid: string | null;
  employeeId: string | null;
  clientId: string;
  contactTypeName: string;
  relationshipName: string;
  phoneCarrierName: string;
  showAdditionalDetails: boolean = false;
}
export class clientFilter {
  clientStatus: number = 0;
}

export class getClient {
  searchColumn: string = "Name";
  searchText: string = "";
  orderColumn: string = "Name";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  agencyId: string;
  statusLid: string;
  employeeTypeLi: string;
  field: string = "name";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "contains";
  type: string = "string";
  locationLid: string = "00000000-0000-0000-0000-000000000000";
}
export class GetUserBo {
  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  name: string;
}

export class onBoardingListBO {
  docToOnboarding: boolean = false;
  datalist: any
  clientid: string
}

export class GetListBase {
  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string = "name";
  orderType: string = "asc";
  type: string = "string";
  field: string = "name";
  operator: string = "contains";
  value: string = "";
  matchCase: boolean = false;
  agencyID: string | null;
  locationID: string | null;
  clientID: string | null;
  statusLId: string | null;
  employeeTypeLid: string | null;
  employeeID: string | null;
}

export class GetListForAgencyBase extends GetListBase {

}

export class GetListForLocationBase extends GetListForAgencyBase {
}

export class GetListForClientBase extends GetListForLocationBase {

}

export interface GetListForEmployeeBase extends GetListForLocationBase {

}

export class GetMenuFunctionalityListBO extends GetListForAgencyBase {
  sideMenuId: string;
}

export class ClientAuthBO {
  Id: string;
}

export class GetAuthListBo {

  orderColumn: string = "payorName";

  type: string = "string";
  field: string = "payorName";
  currentpageno: number = 1;
  orderType: string = "asc";
  pageitem: number = 10;
  operator: string = "startswith";
  value: string;
  matchCase: boolean = false;
  agencyID: string | null;
  locationID: string | null;
  statusLid: string | null;
  employeeId: string | null;
  clientId: string | null;
  state: string;
  relationshipId: string | null;
}

export class saveupdateAuthorizationBo {
  id: string = "00000000-0000-0000-0000-000000000000";
  startDate: string = "";
  endDate: string;
  authTypelid: string;
  groupPayorId: string;
  serviceId: string;
  serviceDescription: string;
  totalhours: number;
  totalNoWeeksOrMonths: number;
  rate: number;
  usedAmt: number | null;
  doesPtoApply: boolean;
  ServiceArrayList: any = [];
  payrollTaxApply: boolean;
  clientId: string;
  isCreate: boolean = false;
  insuranceNumber: string;
  serviceAgreementNumber: string;
  icD10Code: string;
  isTaxable: boolean;
  companyId: string;
  authNote: string;
  icD10Id: string = null;
  inActive: boolean = false;
}

export class disablePortalBO {
  empId: string;
}

export class SendToPortalBO {
  clientId: string;
  agencyNote: string;
  portalLink: string;
  statusLid: string;
  username: string;
  agencyid: string;
}

export class EmployerEmployeeRelationshipTaxPercentBO {
  id: "00000000-0000-0000-0000-000000000000";
  employerEmployeeRelationshipTaxId: string;
  employerEmployeeRelationshipTaxName: string;
  employerEmployeeRelationshipName: string;
  employerEmployeeRelationshipId: string;
  effectiveDate: string;
  percent: number;
  agencyId: string;
  clientId: string | null;
  cliEmpName: string;
   effectiveEndDate: string;

}

export class GetListBO {
  orderColumn: string = "EmployerEmployeeRelationshipName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  agencyID: string;
  field: string = "EmployerEmployeeRelationshipName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith";
  type: string = "string";
  clientId: string | null;
}

export class WhereCondition {
  field: string = "employerEmployeeRelationshipName";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}

export class notesemit {
  isView: boolean = false;
  isEdit: boolean = false;
}

export class functionpermission {
  clientcreate: boolean = true;
  clientupdate: boolean = true;
  authorizationcreate: boolean = true;
  authorizationupdate: boolean = true;
  contactcreate: boolean = true;
  contactupdate: boolean = true;
  contactdelete: boolean = true;
  releationshipcreate: boolean = true;
  releationshipdelete: boolean = true;
  releationshipupdate: boolean = true;
  documentcreate: boolean = true;
  documentupdate: boolean = true;
  documentdelete: boolean = true;
  clientbudgetcreate: boolean = true;
  clientbudgetupdate: boolean = true;
  clientnotescreate: boolean = true
  clientnotesupdate: boolean = true
  clientnotesdelete: boolean = true

}

export class EditDetailsAuthorization {
  isView: boolean = false;
  isEdit: boolean = false;
  isEditAuthorization: boolean = false;
  AuthorizationId: string = '00000000-0000-0000-0000-000000000000';
  AuthorizationData: saveupdateAuthorizationBo = new saveupdateAuthorizationBo();
  ClientId: string = '00000000-0000-0000-0000-000000000000';
  type: string = '';
}
export class ZipcodeDetailBO {
  id: number;
  agencyId: number | null;
  county: string;
  state: string;
  city: string;
  zipcode: string;
}
export class ClientDocumentResultBO{
  count: number;
  result: ClientDocumentBO[];
}
export class ClientDocumentBO{
  documentName: string;
  documentTitle: string;
  // filePath: string;
  attachedDate: string;
  id: string;
  fileExtension: string;
}
export class GetClientDocumentBO{
  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string = "documentTitle";
  orderType: string = "asc";
  type: string = "string";
  field: string = "documentTitle";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
  clientID: string = '00000000-0000-0000-0000-000000000000';
}
export class ClientDocumentFormBO{
  documentTitle: string;
  documentName: string;
  attachedDate: string;
  fileAt: File;
  clientId: string | null = '00000000-0000-0000-0000-000000000000';
}
export class EDI271ClientReportBO {
  clientIdQualifier: string;
  clientID: string;
  clientName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  dOB: string;
  gender: string;
  lastEligibilityCheck: string | null;
  clientPkId: number | null;
  medicaid: string;
  isMAEligible: boolean;
  pMAP: string;
  pmap:string
  program: string;
  waiver: string;
  spendDown: boolean;
  mSHO: boolean;
  msho:boolean;
  messageList: string[];
  messages: string;
  loopDetails: EDI271LoopDetailBO[];
  aAADetails: EDI271AAADetailBO[];
}

export class GetEDI271ClientBO {
  orderColumn: string = "ClientName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  userId: number;
  clientId: number | null;
  agencyId: number | null;
  field: string = "ClientName";
  value: string = "";
  matchCase: boolean = false;
  type: string = "string";
  operator: string = "contains";
  locationId: number | null;
}



